// src/pages/NotFound/NotFound.js
import React from 'react';
import { Link } from 'react-router-dom/';
import notFoundImage from '@/images/mascot.jpg';
import ImgWithFallback from '@/components/atoms/ImgWithFallback';

function NotFound() {
  return (
    <div className="relative py-16 bg-white-app">
      <div className="hidden absolute top-0 inset-x-0 h-1/2 bg-gray-app-50 lg:block" aria-hidden="true" />
      <div className="max-w-7xl mx-auto bg-primary-500 lg:bg-transparent lg:px-8">
        <div className="lg:grid lg:grid-cols-12">
          <div className="relative z-10 lg:col-start-1 lg:row-start-1 lg:col-span-4 lg:py-16 lg:bg-transparent">
            <div className="absolute inset-x-0 h-1/2 bg-gray-app-50 lg:hidden" aria-hidden="true" />
            <div className="max-w-md mx-auto px-4 sm:max-w-3xl sm:px-6 lg:max-w-none lg:p-0">
              <div className="aspect-w-10 aspect-h-6 sm:aspect-w-2 sm:aspect-h-1 lg:aspect-w-1">
                <ImgWithFallback
                  className="object-contain object-center rounded-3xl shadow-2xl"
                  src={notFoundImage}
                  alt="Halaman Tidak Ditemukan - Maskot"
                  quality={85}
                />
              </div>
            </div>
          </div>
          <div className="relative bg-primary-500 lg:col-start-3 lg:row-start-1 lg:col-span-10 lg:rounded-3xl lg:grid lg:grid-cols-10 lg:items-center">
            <div className="hidden absolute inset-0 overflow-hidden rounded-3xl lg:block" aria-hidden="true">
              <svg
                className="absolute bottom-full left-full transform translate-y-1/3 -translate-x-2/3 xl:bottom-auto xl:top-0 xl:translate-y-0"
                width="404"
                height="384"
                fill="none"
                viewBox="0 0 404 384"
                aria-hidden="true"
              >
                <defs>
                  <pattern id="404-pattern" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
                    <rect x="0" y="0" width="4" height="4" className="text-primary-300" fill="currentColor" />
                  </pattern>
                </defs>
                <rect width="404" height="384" fill="url(#404-pattern)" />
              </svg>
            </div>
            <div className="relative max-w-md mx-auto py-12 px-4 space-y-6 sm:max-w-3xl sm:py-16 sm:px-6 lg:max-w-none lg:p-0 lg:col-start-4 lg:col-span-6">
              <h2 className="text-3xl font-extrabold text-white" id="error-heading">
                Waduh, Halaman Hilang! 404
              </h2>
              <p className="text-lg text-white">
                Sepertinya kamu nyasar ke halaman yang nggak ada. Tenang aja, bisa jadi kamu cuma salah ketik
                alamat atau mungkin halamannya udah pindah rumah.
              </p>
              <Link
                className="block w-full py-3 px-5 text-center bg-white border border-transparent rounded-md shadow-md text-base font-medium text-primary-700 hover:bg-gray-app-50 sm:inline-block sm:w-auto"
                to="/"
              >
                Kembali ke Beranda
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NotFound;
